module.exports = __webpack_public_path__ + "static/media/ilhabela-sp.338a795f.jpg";